
import { t } from "i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import AvatarEditor from "widgets/controls/avatar";
import { getRole } from "store/account/accountSelectors";
import { useDefaultImages } from "providers/default-image-provider";
import { userFullname, userProfileImage } from "store/user/userSelectors";
import { setProfileImage } from "store/user/userSlice";

const Banner = () => {
  const { profileBanner } = useDefaultImages();
  const dispatch = useDispatch();
  const avatar = useSelector(userProfileImage, shallowEqual);
  const fullname = useSelector(userFullname, shallowEqual);
  const role = useSelector(getRole, shallowEqual);

  const handleAvatarChange = async (base64Image: string) => {
    dispatch(setProfileImage(base64Image));
  };

  return (
    <div className={"items-center p-4 bg-cover bg-background-50 h-full rounded-[20px]"}>
      {/* background and profile */}
      <div
        className="relative flex h-32 w-full justify-center rounded-2xl bg-cover bg-center"
        style={{ backgroundImage: `url(${profileBanner as string})` }}
      >
        <div className="absolute -bottom-12 flex h-[87px] w-[87px] items-center justify-center">
        <AvatarEditor placeholder="avatar" avatarUrl={avatar || null} onChange={handleAvatarChange} />
        </div>
      </div>
      {/* name and position */}
      <div className="mt-14 flex flex-col items-center">
        <h4 className="heading-lg text-white">{fullname}</h4>
        <div className="my-2 flex items-center justify-center">
          <div className="text-txt-md text-white">
            {t("banner.account.type")}
          </div>
          <div className="mx-2 text-txt-md text-tertiary">
            {role.toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
